import { Box, styled } from "@mui/material";

const CenterBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export default CenterBox;
